export const commitmentDiscountsActions = {
  SELECT_CUD_AWS_SAVINGS_PLAN_TYPE: "SELECT_CUD_AWS_SAVINGS_PLAN_TYPE",
  SELECT_CUD_AWS_SERVICE_TYPE: "SELECT_CUD_AWS_SERVICE_TYPE",
  TOGGLE_CUD_VIEW_TYPE: "TOGGLE_CUD_VIEW_TYPE",
} as const;
